import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { Subscription } from 'rxjs';
import { NipFieldsService } from 'src/app/nip/core/nip-fields.service';
import { Product } from 'src/app/_models/product';
import { ProductType } from 'src/app/_models/product_type';
import { MessService } from 'src/app/_services/mess-service.service';
import { ProductTypesService } from 'src/app/_services/product-types.service';
import { ProductsService } from 'src/app/_services/products.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-products-all-improved',
  templateUrl: './products-all-improved.component.html',
  styleUrls: ['./products-all-improved.component.scss'],
  providers: [DatePipe, MessageService],
})
export class ProductsAllImprovedComponent implements OnInit, OnDestroy {
  products: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };
  subscriptions: Subscription[] = [];
  loading = false;
  productTypes: ProductType[];

  totalPagination: any;
  form: FormGroup;
  @ViewChild('paginatorElement') paginatorElement: Paginator;

  constructor(
    private productsService: ProductsService,
    public fieldsService: NipFieldsService,
    private datePipe: DatePipe,
    private messService: MessService,
    private fb: FormBuilder,
    private productTypesService: ProductTypesService,
    private confirmationService: ConfirmationService
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      label: '',
      name: '',
      product_type_id: '',
    });

    this.getAllProducts();

    this.subscriptions.push(
      this.productTypesService
        .getAllProductTypes()
        .subscribe((productTypes) => {
          this.productTypes = productTypes;
          this.loading = false;
        })
    );

    this.form.valueChanges.pipe(debounceTime(300)).subscribe((filters) => {
      if (filters !== null) {
        this.getAllProducts(1, 10, this.createQueryString(filters));
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getAllProducts(pageIndex = 1, perPage = 100, queryParams = '') {
    this.loading = true;

    this.productsService
      .getAll(pageIndex, perPage, queryParams)
      .subscribe((responseData) => {
        this.totalPagination = responseData.pagination.total;
        this.products.data = responseData.data;

        this.products.pagination = responseData.pagination;
        this.loading = false;
      });
  }

  onEditProduct(productData: Product) {
    console.log(productData);

    this.productsService.updateProductData.next(productData);
  }

  onCopyProduct(productData: Product) {
    this.productsService.copyProductData.next(productData);
  }

  onDeleteProduct(productId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete proizvod?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.productsService.deleteProduct(productId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Uspešno ste obrisali proizvod!',
              });
              this.getAllProducts();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  /* ====================================
 *                HELPERS
 ======================================= */

  onPageChange(event: any) {
    this.getAllProducts(event.page + 1, event.rows);
  }

  onResetFilter() {
    this.form.patchValue({
      label: '',
      name: '',
      product_type_id: '',
    });

    this.getAllProducts();
  }

  createQueryString(form) {
    const query = new URLSearchParams(form).toString().replace('null', '');
    return query;
  }
}
